import { getCountiesWithState } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetCountyOptionsWithState = (
  countyInput: string,
  enabled: boolean,
  statesInput?: string[]
) => {
  return useQuery(
    ['counties', countyInput, statesInput],
    () => getCountiesWithState(countyInput, statesInput),
    {
      enabled: !!enabled,
      staleTime: 300000,
    }
  );
};
